import React, { Component } from 'react';
import { FaInfoCircle as IconInfo } from 'react-icons/fa';
import { safeDeepGetWithType } from 'iotera-base/json';
import { isInteger, isNumber, isEmpty } from 'iotera-base/object';
import { isFloat } from '../../function';
import { toDate, getDateType, toSimpleNumber } from '../formatter';
import { DATE_MONTH, DATE_DAY, DATE_MINUTE, DATE_MINUTE_SECOND } from '../Preference';
/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import { withStyles } from '@material-ui/core';

let createReactClass = require('create-react-class');
let PropTypes = require('prop-types');

export const MaterialLightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

export class InlineTooltip extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  render() {
    return (
      <span>
        <Tooltip TransitionComponent={Zoom} title={this.props.text} enterDelay={500} placement='right'>
          <IconInfo id={this.props.id} data-tip data-for={this.props.id} />
        </Tooltip>
      </span>
    );
  }
}


export const CustomTooltip = createReactClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    let cekdataLabel = safeDeepGetWithType(this, ['props', 'payload', 0, 'payload', 'x'], '')
    let active = safeDeepGetWithType(this, ['props', 'active'], false);
    let sumCount = 0;
    if (isEmpty(cekdataLabel)) active = false
    if (active) {
      let tooltips = [];
      let graphUnitFront = safeDeepGetWithType(this, ['props', 'graph_unit_front'], false);
      let is_second_shown = safeDeepGetWithType(this, ['props', 'is_second_shown'], false);
      let unit = safeDeepGetWithType(this, ['props', 'unit'], '');
      let withSummary = safeDeepGetWithType(this, ['props', 'with_summary'], false);
      let colorFromStroke = safeDeepGetWithType(this, ['props', 'color_from_stroke'], false);
      let payload = safeDeepGetWithType(this, ['props', 'payload'], []);
      let dataLabel = safeDeepGetWithType(this, ['props', 'payload', 0, 'payload', 'x'], '')
      let decimalToShow = safeDeepGetWithType(this, ['props', 'decimal_to_show'], 2);
      let labelDate = toDate(dataLabel, false, false, is_second_shown)
      let type = '';
      if (!isNumber(dataLabel) && !isFloat(dataLabel)) {
        type = getDateType(dataLabel, false, is_second_shown);
        dataLabel = labelDate
      }

      let labelToShow = [];
      let colorGrey = '#B2B2B2';
      if (type === DATE_MONTH) {
        labelToShow = <span><span>{dataLabel.substring(0, dataLabel.length - 4)}</span><span style={{ color: colorGrey }}>{dataLabel.substring(dataLabel.length - 4)}</span></span>
      } else if (type === DATE_DAY) {
        labelToShow = <span><span>{dataLabel.substring(0, dataLabel.length - 3)}</span><span style={{ color: colorGrey }}>{dataLabel.substring(dataLabel.length - 3)}</span></span>
      } else if (type === DATE_MINUTE) {
        labelToShow = <span><span>{dataLabel.substring(0, 6)}</span><span style={{ color: colorGrey }}>{dataLabel.substring(6)}</span></span>
      } else if (type === DATE_MINUTE_SECOND) {
        labelToShow = <span><span>{dataLabel.substring(0, 9)}</span><span style={{ color: colorGrey }}>{dataLabel.substring(9)}</span></span>
      } else {
        labelToShow = dataLabel
      }

      let isIntegerValue = false;
      for (let i = 0; i < payload.length; i++) {
        let name = payload[i].name;
        let value = payload[i].value;
        if (unit === 'Rp' || unit === 'rupiah') {
          if (isInteger(value) || isFloat(value)) {
            value = toSimpleNumber(value, decimalToShow);
            isIntegerValue = true;
          }
        } else {
          if (isInteger(value)) {
            value = toSimpleNumber(value, decimalToShow);
            isIntegerValue = true;
          } else if (isFloat(value)) {
            value = toSimpleNumber(value, decimalToShow);
            isIntegerValue = true;
          }
        }
        sumCount += payload[i].value;

        let currColor = payload[i].color;
        if (colorFromStroke) {
          currColor = payload[i].stroke;
        }
        if (graphUnitFront === true) {
          tooltips.push(
            <p className="intro" key={i} style={{ color: currColor, marginBottom: 0, marginTop: 5 }}>{name} <span style={{ color: colorGrey }}>:</span> <span style={{ color: colorGrey }}>{unit}</span> {value}</p>
          );
        } else {
          tooltips.push(
            <p className="intro" key={i} style={{ color: currColor, marginBottom: 0, marginTop: 5 }}>{name} <span style={{ color: colorGrey }}>:</span> {value} <span style={{ color: colorGrey }}>{unit}</span></p>
          );
        }
      }

      let summary = '';
      if (isIntegerValue) {
        sumCount = toSimpleNumber(sumCount, decimalToShow);
      }

      if (withSummary === true) {
        if (graphUnitFront === true) {
          summary = <div>
            <p style={{ width: '100%', height: '1px', backgroundColor: 'rgb(176, 176, 176)', marginBottom: 10, marginTop: 10 }} />
            <p className="intro" style={{ fontWeight: 'bold' }} >Total : <span style={{ color: colorGrey }}>{unit}</span> {sumCount}</p>
          </div>
        } else {
          summary =
            <div>
              <p style={{ width: '100%', height: '1px', backgroundColor: 'rgb(176, 176, 176)', marginBottom: 10, marginTop: 10 }} />
              <p className="intro" >Total : {sumCount} <span style={{ color: colorGrey }}>{unit}</span></p>
            </div>
        }
      }

      return (
        <div className="view" style={{ backgroundColor: '#fff', outline: 'thin solid #EBF0F5', padding: 10, boxShadow: '0 8px 8px 0 rgba(80, 80, 80, 0.5)' }} >
          <p className="label">{labelToShow}</p>
          <p style={{ width: '100%', height: '1px', backgroundColor: 'rgb(176, 176, 176)', marginBottom: 0 }} />
          {tooltips}
          {summary}
        </div>
      );
    }

    return null;
  }
});

export const CustomTooltipSpbu = createReactClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label } = this.props;
      if (payload[1].value < 300 && payload[1].value !== 0) {
        return (
          <div className="view" style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '5px', backgroundColor: '#fff', outline: 'thin solid #EBF0F5' }} >
            <p className="label">Pukul {`${label}`} (ada indikasi kecurangan!)</p>
            <p className="intro">Sisa bensin : {`${payload[0].value}`}L</p>
            <p className="description">Pengisian tangki :  {`${payload[1].value}`}L </p>
          </div>
        );
      }
      return (
        <div className="view" style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '5px', backgroundColor: '#fff', outline: 'thin solid #EBF0F5' }} >
          <p className="label">Pukul {`${label}`}</p>
          <p className="intro">Sisa bensin : {`${payload[0].value}`}L</p>
          <p className="description">Pengisian tangki :  {`${payload[1].value}`}L</p>
        </div>
      );
    }

    return null;
  }
});

export const CustomizedDotSpbu = createReactClass({
  render() {
    const { cx, cy, payload } = this.props;
    if (payload.dat >= 300 || payload.dat === 0) {
      return (
        <svg x={cx - 10} y={cy - 10} width={20} height={20} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24" enable-background="new 0 0 24 24">
        </svg>
      );
    }

    return (
      <svg x={cx - 10} y={cy - 10} width={20} height={20} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24" enable-background="new 0 0 24 24">
        <path fill="#CC0001" d="M12,0C5.373,0,0,5.373,0,12c0,6.627,5.373,12,12,12c6.627,0,12-5.373,12-12C24,5.373,18.627,0,12,0zM13.316,22.2h-2.605v-3.083h2.605V22.2z M12.757,16.918h-1.513L10.473,1.8h3.054L12.757,16.918z" />
      </svg>
    );
  }
});

export const CustomTooltipShift = createReactClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },
  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label } = this.props;
      let name0 = "", name1 = "", name2 = "";
      if (payload[0].name === "a") {
        name0 = "Premium";
      } else if (payload[0].name === "b") {
        name0 = "Pertamax";
      } else if (payload[0].name === "c") {
        name0 = "Pertalite";
      } else if (payload[0].name === "d") {
        name0 = "Biosolar";
      } else {
        name0 = "Pertamax Turbo";
      }

      if (payload[1].name === "a") {
        name1 = "Premium";
      } else if (payload[1].name === "b") {
        name1 = "Pertamax";
      } else if (payload[1].name === "c") {
        name1 = "Pertalite";
      } else if (payload[1].name === "d") {
        name1 = "Biosolar";
      } else {
        name1 = "Pertamax Turbo";
      }

      if (payload[2].name === "a") {
        name2 = "Premium";
      } else if (payload[2].name === "b") {
        name2 = "Pertamax";
      } else if (payload[2].name === "c") {
        name2 = "Pertalite";
      } else if (payload[2].name === "d") {
        name2 = "Biosolar";
      } else {
        name2 = "Pertamax Turbo";
      }

      return (
        <div className="view" style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '5px', backgroundColor: '#fff', outline: 'thin solid #EBF0F5' }} >
          <p className="label">Pukul {`${label}`}</p>
          <p className="intro" style={{ color: `${payload[2].color}` }}>Totalizer {name2} : {+`${payload[2].value + +370324}`}L (total terjual  {`${payload[2].value}`}L)</p>
          <p className="intro" style={{ color: `${payload[1].color}` }}>Totalizer {name1} : {+`${payload[1].value + +320564}`}L (total terjual  {`${payload[1].value}`}L)</p>
          <p className="intro" style={{ color: `${payload[0].color}` }}>Totalizer {name0} : {+`${payload[0].value + +430565}`}L (total terjual  {`${payload[0].value}`}L)</p>
        </div>
      );
    }

    return null;
  }
});

export const CustomTooltipShifts = createReactClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label } = this.props;
      let name0 = "", name1 = "", name2 = "";
      if (payload[0].name === "a") {
        name0 = "Premium";
      } else if (payload[0].name === "b") {
        name0 = "Pertamax";
      } else if (payload[0].name === "c") {
        name0 = "Pertalite";
      } else if (payload[0].name === "d") {
        name0 = "Biosolar";
      } else {
        name0 = "Pertamax Turbo";
      }

      if (payload[1].name === "a") {
        name1 = "Premium";
      } else if (payload[1].name === "b") {
        name1 = "Pertamax";
      } else if (payload[1].name === "c") {
        name1 = "Pertalite";
      } else if (payload[1].name === "d") {
        name1 = "Biosolar";
      } else {
        name1 = "Pertamax Turbo";
      }

      if (payload[2].name === "a") {
        name2 = "Premium";
      } else if (payload[2].name === "b") {
        name2 = "Pertamax";
      } else if (payload[2].name === "c") {
        name2 = "Pertalite";
      } else if (payload[2].name === "d") {
        name2 = "Biosolar";
      } else {
        name2 = "Pertamax Turbo";
      }

      return (
        <div className="view" style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '5px', backgroundColor: '#fff', outline: 'thin solid #EBF0F5' }} >
          <p className="label">Pukul {`${label}`}</p>
          <p className="intro" style={{ color: `${payload[2].color}` }}>{name2} : {`${payload[2].value}`}L</p>
          <p className="intro" style={{ color: `${payload[1].color}` }}>{name1} : {`${payload[1].value}`}L</p>
          <p className="intro" style={{ color: `${payload[0].color}` }}>{name0} : {`${payload[0].value}`}L</p>
          <p className="intro" >Total :{+`${payload[2].value + payload[1].value + payload[0].value}`}L</p>
        </div>
      );
    }
    return null;
  }
});

export const CustomTooltipLaundry = createReactClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },
  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label } = this.props;
      const code = this.props.code;
      if (code === 1) {
        return (
          <div className="view" style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '5px', backgroundColor: '#fff', outline: 'thin solid #EBF0F5' }} >
            <p className="label">Pukul {`${label}`}</p>
            <p className="intro" style={{ color: `${payload[0].color}` }}>Total Penggunaan : {+`${payload[0].value}`}x</p>
          </div>
        );
      } else {
        return (
          <div className="view" style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '5px', backgroundColor: '#fff', outline: 'thin solid #EBF0F5' }} >
            <p className="label">Pukul {`${label}`}</p>
            <p className="intro" style={{ color: `${payload[0].color}` }}>Total Penggunaan : {+`${payload[0].value}`}</p>
          </div>
        );
      }
    }
    return null;
  }
});

export const CustomTooltipLaundryVending = createReactClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload } = this.props;
      let total1 = 0;
      total1 = payload[0].value + payload[1].value;
      let total2 = 0;
      total2 = payload[2].value + payload[3].value;
      let name0 = "", name1 = "", name2 = "", name3 = "";
      if (payload[0].name === "a") {
        name0 = "Laundry nyala";
      } else if (payload[0].name === "b") {
        name0 = "Laundry mati";
      } else if (payload[0].name === "c") {
        name0 = "Dryer nyala";
      } else if (payload[0].name === "d") {
        name0 = "Dryer mati";
      }

      if (payload[1].name === "a") {
        name1 = "Laundry nyala";
      } else if (payload[1].name === "b") {
        name1 = "Laundry mati";
      } else if (payload[1].name === "c") {
        name1 = "Dryer nyala";
      } else if (payload[1].name === "d") {
        name1 = "Dryer mati";
      }

      if (payload[2].name === "a") {
        name2 = "Laundry nyala";
      } else if (payload[2].name === "b") {
        name2 = "Laundry mati";
      } else if (payload[2].name === "c") {
        name2 = "Dryer nyala";
      } else if (payload[2].name === "d") {
        name2 = "Dryer mati";
      }

      if (payload[3].name === "a") {
        name3 = "Laundry nyala";
      } else if (payload[3].name === "b") {
        name3 = "Laundry mati";
      } else if (payload[3].name === "c") {
        name3 = "Dryer nyala";
      } else if (payload[3].name === "d") {
        name3 = "Dryer mati";
      }

      return (
        <div className="view" style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '5px', paddingTop: '5px', backgroundColor: '#fff', outline: 'thin solid #EBF0F5' }} >
          <p className="label">Saat ini</p>
          <p className="intro" style={{ color: `${payload[0].color}` }}>{name0} : {`${payload[0].value} (${getPercent(`${payload[0].value}`, total1)})`}</p>
          <p className="intro" style={{ color: `${payload[1].color}` }}>{name1} : {`${payload[1].value} (${getPercent(`${payload[1].value}`, total1)})`}</p>
          <p className="intro" style={{ color: `${payload[2].color}` }}>{name2} : {`${payload[2].value} (${getPercent(`${payload[2].value}`, total2)})`}</p>
          <p className="intro" style={{ color: `${payload[3].color}` }}>{name3} : {`${payload[3].value} (${getPercent(`${payload[3].value}`, total2)})`}</p>
        </div>
      );
    }

    return null;
  }
});

const getPercent = (value, total) => {
  const ratio = total > 0 ? value / total : 0;
  return toPercent(ratio, 2);
};

const toPercent = (decimal, fixed = 0) => {
  return `${(decimal * 100).toFixed(fixed)}%`;
};